// SVG geometry retained under the MIT license in LICENSE.txt.
import React from 'react';
import { SvgIcon } from '../primitives';
const CheckBoxOutlineBlank = React.forwardRef(function CheckBoxOutlineBlank(props, ref) {
    return <SvgIcon {...props} ref={ref}><path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/></SvgIcon>;
});
export default CheckBoxOutlineBlank;
